import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Megaphone, X } from "lucide-react";
import {
  focusLandingWordmark,
  readLandingNewsStripDismissed,
  registerLandingStripDismiss,
  writeLandingNewsStripDismissed,
} from "./landingMenu";
import { LANDING_PLAN_CLICK_ALL, track } from "./landingTrack";
import "./LandingNewsStrip.css";

export default function LandingNewsStrip() {
  const [dismissed, setDismissed] = useState(readLandingNewsStripDismissed);

  const dismiss = useCallback(() => {
    writeLandingNewsStripDismissed();
    focusLandingWordmark();
    setDismissed(true);
  }, []);

  useEffect(() => {
    if (dismissed) return;
    registerLandingStripDismiss(dismiss);
    return () => {
      registerLandingStripDismiss(null);
    };
  }, [dismissed, dismiss]);

  if (dismissed) return null;

  return (
    <section className="landing-news" aria-label="news">
      <div className="landing-news__group">
        <Megaphone className="landing-news__icon" size={16} aria-hidden="true" />
        <span className="landing-news__label">Novidades:</span>
        <span className="landing-news__chip">MODELO — [novidade]</span>
        <Link
          className="landing-news__plans"
          to="/planos"
          onClick={() =>
            track("landing_plan_clicked", { product_id: LANDING_PLAN_CLICK_ALL })
          }
        >
          Ver planos
          <ChevronRight size={16} aria-hidden="true" />
        </Link>
      </div>
      <button type="button" className="landing-news__close" aria-label="Fechar novidades" onClick={dismiss}>
        <X size={20} aria-hidden="true" />
      </button>
    </section>
  );
}
